import {
  Flex,
  NumberInput,
  NumberInputField,
  NumberInputProps,
} from '@chakra-ui/react';
import { useField } from 'formik';

export interface NumberFieldProps
  extends Omit<NumberInputProps, 'onChange' | 'value'> {
  name: string;
  leftIcon?: React.ReactNode;
}

export const NumberField = ({ name, leftIcon, ...rest }: NumberFieldProps) => {
  const [field] = useField(name);

  return (
    <NumberInput colorScheme="primary" size="lg" {...rest} {...field}>
      {leftIcon && (
        <Flex
          left={3}
          position="absolute"
          top="50%"
          transform="translateY(-50%)"
        >
          {leftIcon}
        </Flex>
      )}
      <NumberInputField
        bg="input.bg"
        borderRadius="sm"
        pl={leftIcon ? '40px' : 'none'}
        {...field}
      />
    </NumberInput>
  );
};
